export type MetricStatus = 'GOOD' | 'CONCERNING' | 'CRITICAL';

export interface PolicyMetric {
  percent: number;
  count: number;
  totalCount: number;
  status: MetricStatus;
}

export interface PoliciesPublishedMetric {
  total: number;
  percentChange: number;
  status: MetricStatus;
}

export interface DTBsIssuedMetric {
  percent: number;
  agencyIssuedCount: number;
  lexipolIssuedCount: number;
  status: MetricStatus;
}

export interface PolicyMetricsResponse {
  acknowledgments_completed: PolicyMetric;
  dtbs_taken: PolicyMetric;
  lexipol_updates: PolicyMetric;
  policies_published: PoliciesPublishedMetric;
  dtbs_issued: DTBsIssuedMetric;
}

export interface PolicyBarChartDataPoint {
  period: string;
  lexipolUpdates: {
    pendingCount: number;
    processedCount: number;
  };
  assignmentsCompleted: {
    overdueByWeekOrMore: number;
    overdueByLessThanWeek: number;
    onTime: number;
  };
  assignmentsNotCompleted: {
    overdueByWeekOrMore: number;
    overdueByLessThanWeek: number;
  };
}

export interface PolicyBarChartResponse {
  metrics: PolicyBarChartDataPoint[];
}

export interface DTBBarChartDataPoint {
  period: string;
  completedDTBs: {
    onTime: number;
    late: number;
  };
  assignmentsCompleted: {
    overdueByWeekOrMore: number;
    overdueByLessThanWeek: number;
    onTime: number;
  };
  assignmentsNotCompleted: {
    overdueByWeekOrMore: number;
    overdueByLessThanWeek: number;
  };
}

export interface DTBBarChartResponse {
  metrics: DTBBarChartDataPoint[];
}

export interface LexipolUpdatesResponse {
  acceptedCount: number;
  modifiedCount: number;
  rejectedCount: number;
}

export interface AssignmentsDataPoint {
  period: string;
  completedCount: number;
  overdueCount: number;
  acknowledgments: {
    completedCount: number;
    overdueCount: number;
  };
  dtbs: {
    completedCount: number;
    overdueCount: number;
  };
}

export interface AssignmentsResponse {
  metrics: AssignmentsDataPoint[];
}

export enum TimeRangeFilter {
  PREVIOUS_MONTH = 'previousMonth',
  PAST_3_MONTHS = 'past3Months',
  YEAR_TO_DATE = 'yearToDate',
  PAST_12_MONTHS = 'past12Months',
  LAST_CALENDAR_YEAR = 'lastCalendarYear',
  MONTH_TO_DATE = 'monthToDate',
  PAST_30_DAYS = 'past30Days',
  PAST_2_YEARS = 'past2Years',
  PAST_3_YEARS = 'past3Years',
}

